module.exports = __webpack_public_path__ + "img/documents.a48e4c8b.svg";